export const EDITABLE_BOOKING_STATUS_ID = 6;

export const getUrl = (url: string, params: any) => {
  const data = Object.entries(params).map(([name, value]) => ({ name, value }));
  return data?.filter((item) => !!item.value)?.length > 0
    ? joinToString(data, "&", url + "?", "", (item) =>
        item.value ? `${item.name}=${item.value}` : ""
      )
    : url;
};

export function joinToString<T>(
  array: T[],
  separator = ",",
  prefix = "",
  suffix = "",
  transform: (item: T) => string
) {
  let res = prefix;
  for (let i = 0; i < array.length; i++) {
    if (i !== 0 && transform(array[i]) !== "" && res !== prefix) {
      res += separator;
    }
    res += transform(array[i]);
  }
  res += suffix;
  return res;
}
